import { Fail } from './fail';

export class PermissionsFail extends Fail {
  _message = 'Missing permissions for this action';
}
